import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Import your CSS file if you have one

const Exercises = () => {
  return (
    <div className="home-container">
      <header className="home-header">
        <h1>Exercises</h1>
        <p>Select a page to visit:</p>
      </header>
      <main className="home-content">
        <nav className="home-nav">
          <ul>
            <li>
              <Link to="/upload-exercise">Create Exercises</Link>
            </li>
            <li>
              <Link to="/display-exercises">Display Exercises</Link>
            </li>
            <li>
              <Link to="/search-exercises">Filter Exercises</Link>
            </li>
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/">Log-out</Link>
            </li>
          </ul>
        </nav>
      </main>
    </div>
  );
}

export default Exercises;
